import type { Dashboard } from "@/common/types/dashboard";
import axiosClient from "@/lib/axios/axiosClient";

export const getDashboard = async (userId: number): Promise<Dashboard> => {
  const response = await axiosClient.get<Dashboard>(
    `/dashboard?userId=${userId}`,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
      },
    }
  );
  return response.data;
};
